var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1000003662(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6776 17.2316C20.7614 17.2316 21.6368 16.2146 21.6368 14.9557V3.07575C21.6368 1.8169 20.7614 0.799805 19.6776 0.799805H3.58757C2.50378 0.799805 1.62842 1.8169 1.62842 3.07575V14.9474C1.62842 16.2062 2.50378 17.2233 3.58757 17.2233H6.83892L7.11404 20.7998L11.3741 17.3901L19.6776 17.2233V17.2316Z",
    stroke: "#8A91A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36499 7.22731V5.35986H13.5334V9.08642H11.1241V10.5203",
    stroke: "#8A91A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1157 14.2749C11.6943 14.2749 12.1633 13.8059 12.1633 13.2273C12.1633 12.6487 11.6943 12.1797 11.1157 12.1797C10.5371 12.1797 10.0681 12.6487 10.0681 13.2273C10.0681 13.8059 10.5371 14.2749 11.1157 14.2749Z",
    fill: "#8A91A8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000003662);
export default __webpack_public_path__ + "static/media/Group 1000003662.4f11be89ed980be788fa5367d9111021.svg";
export { ForwardRef as ReactComponent };